import React from 'react';
import { connect } from 'react-redux';
import cookie from 'react-cookie';
import { Reception, LetterProcessingWorkFlow, DuLieuHeThong, Danhmuc } from 'api';
import { API_URL} from 'constants/config';
// import Socket from './Socket.jsx';
import {ShowIf} from 'components/utils';

var Promise = require('es6-promise').Promise;
window.debug = false;
class App extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      loading: false,
      initData: false,
      fails: ''
    }
  }
  componentDidMount() {
    this.initData();
  }

  initData() {
    if (cookie.load('accessToken')) {
      this.state.loading = true;
      this.setState({...this.state});
      let self = this;
      setTimeout(function(){
        self.setState({loading: false});
      }, 9000)
      localStorage.removeItem('thamSo');
      this.getTongSoDon();
      // preload data
      Promise.all([
        this.getThamSoHeThong('init'),
        this.getLoaiDonThu('init'),
        this.getHuongXuLyDon('init'),
        this.getKetQuaTiepDan('init'),
        this.getDiaBanTiepNhan('init'),
        this.getCoQuanQuanLy('init'),
        this.getKetLuanNoiDungKhieuNai('init'),
        this.getKetQuaThucHien('init'),
        this.getLanhDaoTiepDan('init'),
      ]).then(responses => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: responses
        })
        this.props.dispatch({
          type: 'INIT_DULIEU',
          value: false
        });
        this.setState({loading: false, initData: true});
      });
    }
  }

  checkSystemData() {
    if (cookie.load('accessToken') && this.state.fails != '') {
      this.getThamSoHeThong(true);
      this.getLoaiDonThu(true);
      this.getHuongXuLyDon(true);
      this.getKetQuaTiepDan(true);
      this.getCoQuanQuanLy(true);
      this.getDiaBanTiepNhan(true);
      this.getKetLuanNoiDungKhieuNai(true);
      this.getKetQuaThucHien(true);
      this.getLanhDaoTiepDan(true);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.init != this.props.init && nextProps.init) {
      this.setState({
        initData: false
      }, () => {
        this.initData();
      })
    }
    if (nextProps.refreshMenu != this.props.refreshMenu && nextProps.refreshMenu) {
      this.getTongSoDon()
    }
  }

  getTongSoDon() {
    DuLieuHeThong.actions.getTongSoDon.request().then(res => {
      if (res && res.data) {
        this.props.dispatch({
          type: 'UPDATE_TONGDON',
          key: 'notifyTongXLD',
          value: res.data.tongSoDonDangXuLy
        });
        this.props.dispatch({
          type: 'UPDATE_TONGDON',
          key: 'notifyTongDonTDTH',
          value: res.data.tongSoDonDangTDTH
        });
        this.props.dispatch({
          type: 'UPDATE_TONGDON',
          key: 'notifyTongDonDK',
          value: res.data.tongSoDonSoTiepCongDanDinhKy
        });
        this.props.dispatch({
          type: 'UPDATE_TONGDON',
          key: 'notifyTongGQD',
          value: res.data.tongSoDonDangGQ
        });
        this.props.dispatch({
          type: 'UPDATE_TONGDON',
          key: 'notifyTongDonDX',
          value: res.data.tongSoDonSoTiepCongDanDotXuat
        });
        this.props.dispatch({
          type: 'UPDATE_TONGDON',
          key: 'notifyTongDonYC',
          value: res.data.tongSoDonYeuCauGapLanhDaoDinhKy
        });
        this.props.dispatch({
          type: 'REFRESH_MENU',
          value: false
        });
      }
    })
  }

  getThamSoHeThong(type) {
    if (type == true && this.state.initData === true && cookie.load('accessToken') && localStorage.getItem('thamSo') && JSON.parse(localStorage.getItem('thamSo')).length == 0 && this.state.fails == 'thamSo') {
      let params = {
        tuKhoa : 'CQQL_BAN_TIEP_CONG_DAN,CQQL_PHONG_NOI_CHINH,CQQL_VAN_PHONG_UBND_THANH_PHO,CCQQL_UBND_QUAN_HUYEN,DVHC_TP_DA_NANG,TQGQ_HANH_CHINH,CQQL_THANH_TRA_THANH_PHO,CQQL_BAN_NOI_CHINH_THANH_UY'
      }
      DuLieuHeThong.actions.getThamSoHeThong.request(null, params).then(res => {
        if(res && res.data && res.data._embedded) {
          let Data = res.data._embedded.thamSoes
          Data.map(item => {
            if (item.ten == 'DVHC_TP_DA_NANG') {
              localStorage.setItem('tpdnId', item.giaTri : '');
            } else if (item.ten == 'TQGQ_HANH_CHINH') {
              localStorage.setItem('thamQuyenHanhChinhId', item.giaTri : '');
            } else {
              let ts = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
              ts = [...ts, {ten: item.ten, giaTri: Number(item.giaTri)}];
              localStorage.setItem('thamSo', JSON.stringify(ts));
            }
          });
          this.props.dispatch({
            type: 'CAPNHAT_DULIEUHETHONG',
            duLieuHeThong: [{
              key: 'thamSo',
              data: Data
            }]
          })
        }
        this.setState({fails: ''})
      })
    } else if (type == 'init') {
      let params = {
        tuKhoa : 'CQQL_BAN_TIEP_CONG_DAN,CQQL_PHONG_NOI_CHINH,CQQL_VAN_PHONG_UBND_THANH_PHO,CCQQL_UBND_QUAN_HUYEN,DVHC_TP_DA_NANG,TQGQ_HANH_CHINH,CQQL_THANH_TRA_THANH_PHO,CQQL_BAN_NOI_CHINH_THANH_UY'
      }
      return DuLieuHeThong.actions.getThamSoHeThong.request(null, params).then(res => {
        if(res && res.data && res.data._embedded) {
          let Data = res.data._embedded.thamSoes
          Data.map(item => {
            if (item.ten == 'DVHC_TP_DA_NANG') {
              localStorage.setItem('tpdnId', item.giaTri : '');
            } else if (item.ten == 'TQGQ_HANH_CHINH') {
              localStorage.setItem('thamQuyenHanhChinhId', item.giaTri : '');
            } else {
              let ts = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
              ts = [...ts, {ten: item.ten, giaTri: Number(item.giaTri)}];
              localStorage.setItem('thamSo', JSON.stringify(ts));
            }
          })
          return Promise.resolve({
            key: 'thamSo',
            data: Data
          });
        }
      }).catch(err => {
        this.setState({fails: 'thamSo'})
        return Promise.resolve({
          key: 'thamSo',
          data: []
        });
      })
    }
  }

  getLoaiDonThu(type) {
    if (type == true && this.state.initData === true && cookie.load('accessToken') && this.props.loaiDonThu.length == 0 && this.state.fails == 'loaiDonThu') {
      Reception.actions.getLoaiDonThu.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'loaiDonThu',
            data: res.data
          }]
        })
        this.setState({fails: ''})
      })
    } else if (type == 'init') {
      return Reception.actions.getLoaiDonThu.request().then(res => {
        return Promise.resolve({
          key: 'loaiDonThu',
          data: res.data
        });
      }).catch(err => {
        this.setState({fails: 'loaiDonThu'})
        return Promise.resolve({
          key: 'loaiDonThu',
          data: []
        });
      })
    }
  }

  getHuongXuLyDon(type) {
    if (type == true && this.state.initData === true && cookie.load('accessToken') && this.props.huongXuLyDon.length == 0 && this.state.fails == 'huongXuLyDon') {
      LetterProcessingWorkFlow.actions.getHuongXuLyDonSearch.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'huongXuLyDon',
            data: res.data
          }]
        })
        this.setState({fails: ''})
      })
    } else if (type == 'init') {
      return LetterProcessingWorkFlow.actions.getHuongXuLyDonSearch.request().then(res => {
        return Promise.resolve({
          key: 'huongXuLyDon',
          data: res.data
        });
      }).catch(err => {
        this.setState({fails: 'huongXuLyDon'})
        return Promise.resolve({
          key: 'huongXuLyDon',
          data: []
        });
      })
    }
  }

  getKetQuaTiepDan(type) {
    if (type == true && this.state.initData === true && cookie.load('accessToken') && this.props.ketQuaTiepDan.length == 0 && this.state.fails == 'ketQuaTiepDan') {
      Reception.actions.getKetQuaTiepDan.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'ketQuaTiepDan',
            data: res.data
          }]
        })
        this.setState({fails: ''})
      })
    } else if (type == 'init') {
      return Reception.actions.getKetQuaTiepDan.request().then(res => {
        return Promise.resolve({
          key: 'ketQuaTiepDan',
          data: res.data
        });
      }).catch(err => {
        this.setState({fails: 'ketQuaTiepDan'})
        return Promise.resolve({
          key: 'ketQuaTiepDan',
          data: []
        });
      })
    }
  }

  getCoQuanQuanLy(type) {
    if (type == true && this.state.initData === true && cookie.load('accessToken') && this.props.coQuanTiepNhan.length == 0 && this.state.fails == 'coQuanTiepNhan') {
      DuLieuHeThong.actions.getCoQuanTiepNhan.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'coQuanTiepNhan',
            data: res.data && res.data._embedded ? res.data._embedded.coQuanQuanLies : []
          }]
        })
        this.setState({fails: ''})
      })
    } else if (type == 'init') {
      return DuLieuHeThong.actions.getCoQuanTiepNhan.request().then(res => {
        return Promise.resolve({
          key: 'coQuanTiepNhan',
          data: res.data && res.data._embedded ? res.data._embedded.coQuanQuanLies : []
        });
      }).catch(err => {
        this.setState({fails: 'coQuanTiepNhan'})
        return Promise.resolve({
          key: 'coQuanTiepNhan',
          data: []
        });
      })
    }
  }

  getDiaBanTiepNhan(type) {
    if (type == true && this.state.initData === true && cookie.load('accessToken') && this.props.coQuanTiepNhan.length === 0 && this.state.fails == 'diaBanTiepNhan') {
      DuLieuHeThong.actions.getDiaBanTiepNhan.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'diaBanTiepNhan',
            data: res.data && res.data._embedded ? res.data._embedded.coQuanQuanLies : []
          }]
        });
        this.setState({fails: ''});
      });
    } else if (type === 'init') {
      return DuLieuHeThong.actions.getDiaBanTiepNhan.request().then(res => {
        return Promise.resolve({
          key: 'diaBanTiepNhan',
          data: res.data && res.data._embedded ? res.data._embedded.coQuanQuanLies : []
        });
      }).catch(err => {
        this.setState({fails: 'diaBanTiepNhan'})
        return Promise.resolve({
          key: 'diaBanTiepNhan',
          data: []
        });
      });
    }
  }

  getKetLuanNoiDungKhieuNai(type) {
    if (type == true && this.state.initData === true && cookie.load('accessToken') && this.state.fails === 'ketLuanNoiDungKhieuNai') {
      let params={
        loaiDon: 'DON_KIEN_NGHI_PHAN_ANH'
      }
      DuLieuHeThong.actions.getKetLuanNoiDungKhieuNai.request('', params).then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'ketLuanNoiDungKhieuNai',
            data: res.data || []
          }]
        });
        this.setState({fails: ''});
      });
    } else if (type === 'init') {
      let params={
        loaiDon: 'DON_KIEN_NGHI_PHAN_ANH'
      }
      return DuLieuHeThong.actions.getKetLuanNoiDungKhieuNai.request('', params).then(res => {
        return Promise.resolve({
          key: 'ketLuanNoiDungKhieuNai',
          data: res.data
        });
      }).catch(err => {
        this.setState({fails: 'ketLuanNoiDungKhieuNai'})
        return Promise.resolve({
          key: 'ketLuanNoiDungKhieuNai',
          data: []
        });
      });
    }
  }

  getKetQuaThucHien(type) {
    if (type == true && this.state.initData === true && cookie.load('accessToken') && this.props.ketQuaThucHien.length == 0 && this.state.fails == 'ketQuaThucHien') {
      DuLieuHeThong.actions.getKetQuaThucHien.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'ketQuaThucHien',
            data: res.data || []
          }]
        })
        this.setState({fails: ''})
      })
    } else if (type == 'init') {
      return DuLieuHeThong.actions.getKetQuaThucHien.request().then(res => {
        return Promise.resolve({
          key: 'ketQuaThucHien',
          data: res.data
        });
      }).catch(err => {
        this.setState({fails: 'ketQuaThucHien'})
        return Promise.resolve({
          key: 'ketQuaThucHien',
          data: []
        });
      })
    }
  }

  getLanhDaoTiepDan(type) {
    if (type == true && this.state.initData === true && cookie.load('accessToken') && this.props.lanhDaoList.length == 0 && this.state.fails == 'lanhDaoList') {
      DuLieuHeThong.actions.getListLanhDao.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'lanhDaoList',
            data: res.data._embedded ? res.data._embedded.congChucs : []
          }]
        })
        this.setState({fails: ''})
      })
    } else if (type == 'init') {
      return DuLieuHeThong.actions.getListLanhDao.request().then(res => {
        return Promise.resolve({
          key: 'lanhDaoList',
          data: res.data._embedded ? res.data._embedded.congChucs : []
        });
      }).catch(err => {
        this.setState({fails: 'lanhDaoList'})
        return Promise.resolve({
          key: 'lanhDaoList',
          data: []
        });
      })
    }
  }

  onMessage(msg) {
    this.props.dispatch({
      type: 'NEW_MSG',
      data: msg
    })
  }

  render() {
    let CheckSystemData = this.checkSystemData();
    return (
      <div className={this.state.loading === true ? "wrapper lock" : "wrapper"}>
        <ShowIf condition={this.state.loading === true}>
          <div className='wrap-loading'><img src={require('assets/images/blue_loading.gif')}/></div>
        </ShowIf>
        {this.props.children}
        {/*<Socket url={API_URL+'/ws'} topics={[`/queue/notify`]} onMessage={this.onMessage.bind(this)} ref={(client) => { this.clientRef = client }} />*/}
      </div>
    );
  }
}
App.defaultProps = {
  init: false,
  refreshMenu: false
}
function bindStateToProps(state) {
  return {
    init: state.duLieuHeThong.init,
    initIDTP: state.duLieuHeThong.initIDTP,
    refreshMenu: state.duLieuHeThong.refreshMenu,
    loaiDonThu: state.duLieuHeThong.loaiDonThu,
    huongXuLyDon: state.duLieuHeThong.huongXuLyDon,
    ketQuaTiepDan: state.duLieuHeThong.ketQuaTiepDan,
    coQuanTiepNhan: state.duLieuHeThong.coQuanTiepNhan,
    ketLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    thamSo: state.duLieuHeThong.thamSo
  }
}
export default connect(bindStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/app/App.jsx